import Card from "components/Card/Card.jsx";
import CardBody from "components/Card/CardBody.jsx";
import GridContainer from "components/Grid/GridContainer.jsx";
import GridItem from "components/Grid/GridItem.jsx";
import { Proxy, withArtifex } from "core";
import ClientHelper from "core/ClientHelper";
import { EditIcon } from "core/Icons";
import PropTypes from "prop-types";
import React from "react";
import ButtonToolbar from "views/Components/ButtonToolbar.jsx";
import CustomerComponent from "views/Components/CustomerComponent";
import { GenericAlert, GenericCheckInput, GenericExpansionPanel, GenericGrid, GenericNumberInput, GenericSelectInput, GenericTextInput } from "views/Components/Generic";
import LoadingComponent from "views/Components/LoadingComponent";
import ToolbarButton from "views/Components/ToolbarButton";
import { ProgramCodes } from "views/Constants/Constant.js";
import GridButton from "views/Components/GridButton";

class AssignAccount extends React.Component {
	constructor(props) {
		super(props);

		this.emptyModel = {
			Id: null,
			Country: null,
			UniqueClientId: null,
			Customer: null,
			SelectedAccount: null,
			SelectedCard: null,
			HasCardUsageLimit: false,
			CardUsagePeriodId: null,
			CardUsageLimit: null,
			AccountList: [],
		};

		this.initialDialogModel = {
			IsDialogOpen: false,
			SelectedCard: null
		};

		this.columns = [
			{
				Header: "Actions",
				accessor: "Actions",
				Cell: row => (
					<div>
						<GridButton
							tooltip="Modify"
							OnClick={() => { this.handleSelect(row.original, row.index); }}
							Icon={EditIcon} 
						/>
					</div>
				),
				sortable: false,
				filterable: false,
				resizable: false,
				width: 80
			},
			{
				Header: "Cardholder Name",
				accessor: "EmbossName1"
			},
			{
				Header: "Masked Card Number",
				accessor: "CardNumber"
			},
			{
				Header: "Balance",
				accessor: "CardBalance"
			},
			{
				Header: "Limit",
				Cell: row => (
					<div>
						{row.original.HasCardUsageLimit ? row.original.CardUsageLimit : ""}
					</div>
				)
			},
			{
				Header: "Limit Period",
				Cell: row => (
					<div>
						{row.original.HasCardUsageLimit ? (row.original.CardUsagePeriod != null ? row.original.CardUsagePeriod.ParameterDesc : "") : ""}
					</div>
				)
			},
			{
				Header: "Wallet Number",
				accessor: "AccountNumber"
			},
			{
				Header: "Wallet Program",
				accessor: "AccountProgram"
			}
		];

		this.state = {
			alert: null,
			list: [],
			lastFilterModel: this.emptyModel,
			model: this.emptyModel,
			isLoading: false
		};
	}

	componentDidMount() {
		this.props.setAppLeftTitle("Change Card Default Wallet");
		this.props.setAppCenterTitle("PREPAID CARD MANAGEMENT");
	}

	handleChange = (name, newValue, data) => {
		const model = { ...this.state.model };
		const dialogModel = { ...this.state.dialogModel };
		const emptyModel = { ...this.emptyModel };

		if (name === "Customer") {
			if (newValue != null) {
				model.Customer = newValue;
				if (newValue.Accounts != null && newValue.Accounts.length > 0) {
					model.AccountList = newValue.Accounts;
				} else {
					model.AccountList = [];
				}
			} else {
				model.Customer = emptyModel.Customer;
				model.AccountList = [];
			}
		} else if (name === "UniqueClientId") {
			if (ClientHelper.IsClient() && emptyModel.UniqueClientId == null && newValue != null) {
				this.emptyModel.UniqueClientId = newValue;
			}
			model.UniqueClientId = newValue;
		} else if (name === "Account") {
			model.SelectedAccount = newValue;
		} else if (name === "HasCardUsageLimit") {
			model.HasCardUsageLimit = newValue;
		} else if (name === "CardUsagePeriodId") {
			model.CardUsagePeriodId = newValue;
		} else if (name === "CardUsageLimit") {
			model.CardUsageLimit = newValue;
		}

		this.setState({ model });
	};

	handleClear = () => {
		this.setState({
			model: this.emptyModel,
			alert: null,
			list: []
		});
	};

	loadAccount = (action) => {
		const { model } = this.state;
		const request = {
			UniqueClientId: model.UniqueClientId,
			ClientCustomerId: model.Customer == null ? null : model.Customer.Id
		};
		Proxy.ExecuteGeneral(
			this, "POST",
			"/bankapi/v1.0/ClientCustomer/SearchBankAccount",
			request,
			responseData => {
				model.AccountList = responseData.Item;
				this.setState({ model }, action);
			}
		);
	}

	handleSearch = () => {
		if (!this.validateSearch()) {
			return;
		}

		this.loadAccount(() => {
			const { model } = this.state;
			this.search(model);
		});
	};

	search = (model) => {
		const request = {
			UniqueClientId: model.UniqueClientId,
			ClientCustomerId: model.Customer == null ? null : model.Customer.Id
		};

		this.setState({ isLoading: true });
		Proxy.ExecuteGeneral(
			this, "POST",
			"/prepaidapi/v1.0/Card/GetCardSummaryList",
			request,
			responseData => {
				var list = [];
				if (responseData.Item != null && responseData.Item[0] != null) {
					list = responseData.Item;
				}
				this.setState({ list: list, lastFilterModel: model, isLoading: false });
			}
		);
	}

	handleSubmit = () => {
		if (!this.validateUpdate()) {
			return;
		}

		this.setState({ isLoading: true });
		const { model, lastFilterModel } = this.state;
		const request = {
			UniqueClientId: model.UniqueClientId,
			CardId: model.SelectedCard == null ? null : model.SelectedCard.Id,
			BankAccountId: model.SelectedAccount,
			HasCardUsageLimit: model.HasCardUsageLimit,
			CardUsageLimitPeriodId: model.HasCardUsageLimit ? model.CardUsagePeriodId : null,
			CardUsageLimit: model.HasCardUsageLimit ? model.CardUsageLimit : null,
		};

		Proxy.ExecuteGeneral(
			this, "POST",
			"/prepaidapi/v1.0/Prepaid/UpdateCardAccountAndUsageLimit",
			request,
			responseData => {
				model.SelectedCard = null;
				model.SelectedAccount = null;
				model.CardUsageLimit = null;
				model.CardUsagePeriodId = null;
				model.HasCardUsageLimit = false;
				this.setState({ model, isLoading: false }, () => { this.search(lastFilterModel); });
			}
		);
	};

	handleSelect = (data, index) => {
		const { model } = this.state;
		var clonedData = Object.assign({}, data);
		model.SelectedCard = clonedData;
		model.SelectedAccount = clonedData.AccountId;
		model.HasCardUsageLimit = clonedData.HasCardUsageLimit;
		model.CardUsageLimit = clonedData.CardUsageLimit;
		model.CardUsagePeriodId = clonedData.CardUsagePeriodId;
		this.setState({ model });
	};

	validateSearch = () => {
		var errorList = [];
		const { model } = this.state;

		if (model.UniqueClientId == null || model.UniqueClientId == 0) {
			errorList.push("Client must be selected!");
		}

		if (model.Customer == null || model.Customer.Id == null || model.Customer.Id == 0) {
			errorList.push("Customer must be selected!");
		}

		if (errorList.length > 0) {
			this.ShowMessageNode("warning", "Required fields!", errorList.map((x, i) => <div key={i}>{x}</div>));
			return false;
		}
		return true;
	}

	validateUpdate = () => {
		var errorList = [];
		const { model } = this.state;

		if (model.UniqueClientId == null || model.UniqueClientId == 0) {
			errorList.push("Client must be selected!");
		}

		if (model.Customer == null || model.Customer.Id == null || model.Customer.Id == 0) {
			errorList.push("Customer must be selected!");
		}

		if (model.SelectedCard == null || model.SelectedCard.Id == null || model.SelectedCard.Id == 0) {
			errorList.push("Card must be selected!");
		}

		if (model.SelectedAccount == null || model.SelectedAccount == 0) {
			errorList.push("New wallet must be selected!");
		}

		if (errorList.length > 0) {
			this.ShowMessageNode("warning", "Required fields!", errorList.map((x, i) => <div key={i}>{x}</div>));
			return false;
		}
		return true;
	}

	render() {
		const { Disabled } = this.props;
		const { model, alert, list, isLoading } = this.state;
		return (
			<div>


				<LoadingComponent Show={isLoading} />

				{alert}
				<ButtonToolbar
					ButtonList={[
						{ Code: "Search", OnClick: this.handleSearch, Disabled: Disabled, ValidationFunction: this.validateSearch },
						{ Code: "Update", OnClick: this.handleSubmit, Disabled: (Disabled || model.SelectedCard == null || model.SelectedCard.Id == 0), ValidationFunction: this.validateUpdate },
						{ Code: "Clear", OnClick: this.handleClear, Disabled: Disabled }
					]}
					menuId={this.props.menuId}
					ApprovalData={this.props.ApprovalData}
					After={this.props.After}
				/>
				<GridContainer spacing={16}>
					<GridItem xs={12}>
						<Card>
							<CardBody>
								<GenericExpansionPanel>
									<GridContainer>
										<GridItem xs={3}>
											<GenericSelectInput
												Name="UniqueClientId"
												LabelText="Client"
												Method="POST"
												Url="/bankapi/v1.0/BankCustomer/Search"
												Parameter={{ UniqueClientId: ClientHelper.IsClient() ? ClientHelper.GetClientId() : null }}
												DataRoot="Item"
												KeyValueMember="Id"
												RenderItem={d => `${d.UniqueClientId} - ${d.Name}`}
												Value={model.UniqueClientId || ""}
												ValueChanged={this.handleChange}
												CanClear
												All
												Disabled={ClientHelper.IsClient()}
												DefaultIndex={ClientHelper.IsClient() ? 0 : 0} />
										</GridItem>
										<GridItem xs={3}>
											<CustomerComponent
												CustomerNumber={model.Customer == null ? null : model.Customer.CustomerNumber}
												UniqueClientId={model.UniqueClientId}
												FillCallback={customer => { this.handleChange("Customer", customer, null); }}
												Programs={[ProgramCodes.Prepaid]}
												Disabled={model.UniqueClientId == null}
												ShowCustomerProgram={true}
												LabelMd={5} />
										</GridItem>
										<GridItem xs={3}>
											<GenericTextInput
												Name="CardNumber"
												IsText
												LabelText="Card Number"
												Value={model.SelectedCard == null ? "" : model.SelectedCard.CardNumber}
												Disabled />
										</GridItem>
										<GridItem xs={3}>
											<GenericSelectInput
												Name="Account"
												LabelText="Wallet"
												IsStatic={true}
												StaticData={model.AccountList}
												DataRoot="Item"
												KeyValueMember="AccountId"
												RenderItem={d => `${d.AccountNumber} - ${d.AccountName}`}
												Value={model.SelectedCard == null ? null : model.SelectedAccount}
												ValueChanged={this.handleChange}
												Disabled={model.SelectedCard == null} />
										</GridItem>
										<GridItem xs={3}>
											<GenericCheckInput
												Name="HasCardUsageLimit"
												LabelText="Has Card Usage Limit"
												Value={model.SelectedCard == null ? null : model.HasCardUsageLimit}
												Disabled={model.SelectedCard == null}
												ValueChanged={this.handleChange} />
										</GridItem>
										<GridItem xs={3} style={{ opacity: !model.HasCardUsageLimit ? 0.4 : 1 }}>
											<GenericSelectInput
												Name="CardUsagePeriodId"
												LabelText="Card Usage Period"
												Method="POST"
												Url="/coreapi/v1.0/Parameter/Search"
												Parameter={{ ParameterCode: "LoadingPeriod" }}
												DataRoot="Item"
												KeyValueMember="Id"
												TextValueMember="ParameterDesc"
												Value={model.HasCardUsageLimit ? model.CardUsagePeriodId : false}
												Disabled={!model.HasCardUsageLimit}
												ValueChanged={this.handleChange}
												LabelMd={5} />
										</GridItem>
										<GridItem xs={3} style={{ opacity: !model.HasCardUsageLimit ? 0.4 : 1 }}>
											<GenericNumberInput
												Name="CardUsageLimit"
												LabelText="Card Usage Limit"
												Value={model.HasCardUsageLimit ? model.CardUsageLimit : null}
												ValueChanged={this.handleChange}
												Prefix="$"
												Disabled={!model.HasCardUsageLimit}
												MaxLength={12} />
										</GridItem>
									</GridContainer>
								</GenericExpansionPanel>
							</CardBody>
						</Card>
						<Card>
							<CardBody>
								<GridContainer>
									<GridItem xs={12}>
										<GridContainer spacing={16}>
											<GridItem xs={12}>
												<GenericGrid
													Data={list}
													Columns={this.columns}
													ProgramCode={ProgramCodes.Prepaid} />
											</GridItem>
										</GridContainer>
									</GridItem>
								</GridContainer>
							</CardBody>
						</Card>
					</GridItem>
				</GridContainer>
			</div>
		);
	}

	ShowMessage = (type, title, message) => {
		this.setState({
			alert: (
				<GenericAlert
					Title={title}
					Message={message}
					Type={type}
					OnConfirm={() => this.setState({ alert: "" })}
				/>
			)
		});
	};

	ShowMessageNode = (type, title, message) => {
		this.setState({
			alert: (
				<GenericAlert
					Title={title}
					MessageNode={message}
					Type={type}
					OnConfirm={() => this.setState({ alert: "" })}
				/>
			)
		});
	};

	ShowConfirmMessage = (type, title, message, onConfirm) => {
		this.setState({
			alert: (
				<GenericAlert
					Title={title}
					Message={message}
					Type={type}
					ShowCancel={true}
					OnCancel={() => this.setState({ alert: "" })}
					OnConfirm={onConfirm}
				/>
			)
		});
	};
}

AssignAccount.propTypes = {
	classes: PropTypes.object,
	setAppLeftTitle: PropTypes.func,
	setAppCenterTitle: PropTypes.func,
	Disabled: PropTypes.bool,
	handleChange: PropTypes.func,
	menuId: PropTypes.number,
	ApprovalData: PropTypes.any,
	After: PropTypes.any
};

export default withArtifex(AssignAccount, {});
